import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { SearchFormField } from '../types';

export const useSearchFormFieldStore = defineStore(
  'search-form-field-store',
  () => {
    const activeFormField = ref<SearchFormField>();
    function setActiveFormField(field: SearchFormField) {
      activeFormField.value = field;
    }
    function resetActiveFormField() {
      activeFormField.value = undefined;
    }
    function isActiveFormField(field: SearchFormField) {
      return activeFormField.value === field;
    }
    return {
      activeFormField,
      isActiveFormField,
      setActiveFormField,
      resetActiveFormField,
    };
  },
);
